import { atom } from 'jotai';

import { V2OrderSideType } from '@flipster/utils/types/base';
import { valueof } from '@flipster/utils/typescript';

import { updateV2SocketData } from '../v2-helper';
import { createTableAccumulatorBunja } from './table-accumulator';

export type Orders = Record<string, Order> | null;

/**
 * open position의 tp: CONDITIONAL_ORDER_TYPE_POSITION_TP
 * open position의 sl: CONDITIONAL_ORDER_TYPE_POSITION_SL
 * pending order의 tp/sl: CONDITIONAL_ORDER_TYPE_INVALID
 * pending order의 경우 private/orders의 orderTpTriggerPrice, orderSlTriggerPrice로 오기 때문에 따로 타입이 없음
 */
export const ConditionalOrderTypeEnum = {
  Invalid: 'CONDITIONAL_ORDER_TYPE_INVALID',
  PositionTp: 'CONDITIONAL_ORDER_TYPE_POSITION_TP',
  PositionSl: 'CONDITIONAL_ORDER_TYPE_POSITION_SL',
} as const;

export type ConditionalOrderType = valueof<typeof ConditionalOrderTypeEnum>;

export interface Order {
  orderId: string;
  slot: number;
  symbol: string;
  initLeverage: number;
  side: V2OrderSideType;
  qty?: string; // amount 주문시 빈값
  amount?: string; // qty 주문시 빈값
  leavesAmount: string;
  isReduceOnly: boolean;
  /** @deprecated replace to conditionalOrderType */
  action: 'Open' | 'Close';
  triggerPrice: string;
  triggerDirection: 'Up' | 'Down';
  orderTpOrderQty: null | string;
  orderSlOrderQty: null | string;
  orderTpTriggerPrice: null | string;
  orderSlTriggerPrice: null | string;
  orderTpTriggerPriceRatio: null | string;
  orderSlTriggerPriceRatio: null | string;
  conditionalOrderType: ConditionalOrderType;
  triggerTimestamp?: string | null; // https://prextech.slack.com/archives/C087D884VEE/p1738738496172539?thread_ts=1738737123.709789&cid=C087D884VEE
}

export interface PendingPosition extends Order {
  orderType: 'qty' | 'amount';
  qty: string; // precision tradeQtyPrecision
  amount: string;
}

export const ordersAtom = atom<Orders>(null);

export const subscribeOrdersBunja = createTableAccumulatorBunja(
  'private/orders',
  (store) => (wsData) => store.set(ordersAtom, (prev) => updateV2SocketData(prev || {}, wsData)),
);
